export const JOB_STATUS_PRESENTATION = {
    queued: { label: 'Queued', variant: 'neutral' },
    running: { label: 'Running', variant: 'info' },
    succeeded: { label: 'Succeeded', variant: 'success' },
    succeeded_with_errors: { label: 'Succeeded with errors', variant: 'warning' },
    failed: { label: 'Failed', variant: 'danger' },
};

export const TRIGGER_LABELS = { manual: 'Manual', scheduled: 'Scheduled' };
